import { NAVY, WHITE_BACKGROUND } from 'styles/Colors';
import React from 'react';

function Fieldset({ label, children, customStyle = {}, style = {} }) {
  const fieldsetStyle = {
    border: `3px solid ${NAVY}`,
    padding: '2rem 1.25rem',
    borderRadius: '2px',
    position: 'relative',
    backgroundColor: WHITE_BACKGROUND
  };

  const childrenStyle = {
    ' > *:not(:last-child)': {
      marginBottom: '1.25rem'
    }
  };

  const labelStyle = {
    background: WHITE_BACKGROUND,
    padding: '0 0.5rem',
    textAlign: 'center',
    margin: 'auto',
    fontSize: '1.125rem',
    color: NAVY
  };

  return (
    <fieldset css={[fieldsetStyle, style]}>
      {label && <legend css={labelStyle}>{label}</legend>}
      <div css={[childrenStyle, customStyle]}>{children}</div>
    </fieldset>
  );
}

export default Fieldset;
